import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import { fromJS } from 'immutable'
import { Colors, Fonts, Metrics } from '../../Themes'
import Arrow from '../../svg-icons/Arrow'
import Loader from '../../components/Loader'

const rowMargins = 60

const Container = styled.div`
  position: relative;
  max-width: 100vw;
  overflow-x: scroll;

  .noElements{
    position: absolute;
    top: 80px;
    width: 170px
    left: calc((100% - 170px)/2 + ${props => props.left}px);
    span {
      ${Fonts.style.Text};
      margin-top: 0;
    }
  }
`

const TableContainer = styled.table`
  display: block;
  width: ${props => (props.width ? `${props.width}px` : '100%')};
  min-height: calc(
    100vh - (${Metrics.components.searchbar} +
          ${Metrics.components.navbarDefault})
  );
  height: ${props => (props.height ? `${props.height}px` : '100%')};
  border-spacing: 0;
`

const Wrapper = styled.div`width: auto;`

const TableBody = styled.tbody`
  background: ${Colors.white};
  ${props => props.width && `width: ${props.width}px`};
  height: calc(100% - 60px);
  overflow: hidden;
  overflow-y: scroll;
  display: block;
`

const TableHeader = styled.thead`
  ${props => props.width && `width: ${props.width}px`};
  background: black;
  height: 60px;
  padding: 24px ${Metrics.margins.larger};
  display: block;
  text-align: left;
`

const HeaderCell = styled.th`
  ${Fonts.style.Input};
  color: ${Colors.white};
  position: relative;
  cursor: pointer;
  ${props => props.width && `width: ${props.width}px`};
  svg {
    fill: ${Colors.primary};
    position: absolute;
    top: -5px;
    margin-left: ${Metrics.margins.small};
    &.desc {
      transform: rotate(180deg);
    }
  }
`

const Row = styled.tr`
  padding-left: ${Metrics.margins.larger};
  padding-right: ${Metrics.margins.larger};
  display: table-row;
  height: 60px;
  cursor: pointer;
  &:hover {
    background: ${Colors.lightGrey};
  }
`

const Cell = styled.td`
  vertical-align: middle;
  height: 60px;
  border-bottom: solid 1px rgba(72, 72, 72, 0.14);
  ${Fonts.style.Text};
  ${props => props.width && `width: ${props.width}px`};
  svg {
    height: 50px;
    &.notFavorite {
      path {
        fill: ${Colors.black};
      }
    }
  }

  &.title {
    color: ${Colors.primary};
  }
`

class Table extends Component {
  constructor (props) {
    super(props)
    this.state = {
      leftScroll: 0
    }
    this.handleScroll = this.handleScroll.bind(this)
    this.handleScrollLeft = this.handleScrollLeft.bind(this)
  }

  shouldComponentUpdate (nextProps) {
    const {
      data,
      canLoadMore,
      isFetching,
      height,
      width,
      selectedElements,
      keys
    } = this.props
    if (
      nextProps.canLoadMore !== canLoadMore ||
      nextProps.isFetching !== isFetching ||
      nextProps.height !== height ||
      nextProps.width !== width ||
      !fromJS(nextProps.data).equals(fromJS(data)) ||
      !fromJS(nextProps.keys).equals(fromJS(keys)) ||
      (selectedElements &&
        !fromJS(nextProps.selectedElements).equals(fromJS(selectedElements)))
    ) {
      return true
    }
    return false
  }

  handleScrollLeft (event) {
    const position = document.getElementById('tableContainer').scrollLeft
    this.setState({ leftScroll: position })
  }

  handleScroll (event) {
    const { loadMore, canLoadMore, isFetching } = this.props
    const element = document.getElementById('table-body')
    var hiddenPixels = element.scrollTop
    var difference = element.scrollHeight - element.clientHeight
    var scrollPrecentage = hiddenPixels / difference * 100

    if (loadMore && canLoadMore && !isFetching && scrollPrecentage > 90) {
      loadMore()
    }
  }

  render () {
    const { keys, height, data, rowClick, handleSort, isFetching } = this.props
    let totalWidth = 0
    const headers =
      keys.length > 0 &&
      keys.map((el, index) => {
        totalWidth += el.width
        return (
          <HeaderCell
            onClick={() => (el.onClick ? el.onClick() : handleSort(el))}
            width={el.width}
            key={`key-${el.key}`}>
            {el.title}
            {el.unit && ` (${el.unit})`}
            {el.sort && <Arrow className={`${el.sort === 1 && 'desc'}`} />}
          </HeaderCell>
        )
      })
    totalWidth += rowMargins // due to the margins
    totalWidth =
      totalWidth < window.screen.availWidth
        ? window.screen.availWidth
        : totalWidth
    const rows =
      data.length > 0 &&
      keys.length > 0 &&
      data.map((el, index) => {
        return (
          <Row key={`row-${index}`}>
            {keys.map(keyObj => {
              return (
                <Cell
                  onClick={() => rowClick(el.id)}
                  key={`row-${keyObj.key}-${index}`}
                  className={keyObj.key}
                  width={keyObj.width}>
                  {keyObj.accessor ? keyObj.accessor(el) : el[keyObj.key]}
                </Cell>
              )
            })}
          </Row>
        )
      })

    const noElements = data.length === 0 && (
      <div id='noElements' className='noElements'>
        <span>There are no elements</span>
      </div>
    )
    return (
      <div>
        <Loader visible={isFetching} width={100} height={100} />
        <Container
          id='tableContainer'
          onScroll={this.handleScrollLeft}
          left={this.state.leftScroll}>
          <Wrapper>
            <TableContainer height={height} width={totalWidth}>
              <TableHeader>
                <tr>{headers}</tr>
              </TableHeader>
              <TableBody id='table-body' onScroll={this.handleScroll}>
                {rows}
              </TableBody>
            </TableContainer>
          </Wrapper>
          {noElements}
        </Container>
      </div>
    )
  }
}

Table.propTypes = {
  keys: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  canLoadMore: PropTypes.bool,
  isFetching: PropTypes.bool,
  rowClick: PropTypes.func,
  loadMore: PropTypes.func,
  height: PropTypes.number,
  width: PropTypes.number,
  handleSort: PropTypes.func,
  selectedElements: PropTypes.array
}

export default Table



// WEBPACK FOOTER //
// ./src/components/Table/index.js